import GhaModel from '../models/Gha';
import { InvoiceAccountType } from '../models/ForwarderAccountAndConfig';

const GHA_SCHEMA: GhaModel = {
  id: -1,
      name:'',
      info: {
        name: '',
        address: '',
        po_support: false,
        tz: '',
        ticker: '',
        tel: '',
        shortName: '',
        location: '',
        cams: [],
        serviceDescriptions: {
          breakdown_hawb: '',
          bup_ld3: '',
          bup_ld7: '',
          bup_20ft: '',
          bup_q7: '',
          label_freight: '',
          bup_main_deck: '',
          import_service: '',
          return_fee: '',
          other: '',
          gha_adjust: '',
          per_hawb: '',
          per_hawb_exclude_import_service: '',
          reicing: '',
          storage_fee: '',
          perishable_storage: '',
          customs_fee: '',
          cage_vault: '',
          skid_exch: '',
          comat: '',
          copa_comat: '',
          nomination_fee: '',
          certified_manifest_charge: 'Certified Manifest Charge'
        }
      },
      tariff: {
        other: {},
        gha_adjust: {},
        bup_ld3: {
          cost_usd: 0
        },
        bup_ld7: {
          cost_usd: 0
        },
        bup_20ft: { cost_usd: 0 },
        bup_q7: { cost_usd: 0 },
        label_freight: { cost_per_box_usd: 0 },
        reicing: {
          cost_per_kg_usd: 0
        },
        per_hawb: {
          cost_per_hawb_usd: 0
        },
        per_hawb_exclude_import_service: {
          cost_per_hawb_usd: 0
        },
        storage_fee: { 
          free_days: 0, min_cost_usd: 0, storage_divisor: 0, first_weekend_free: false, arrival_day_counted: false, 
          all_public_holidays_counted: false, first_public_holiday_counted: false, cost_per_storage_unit_per_day_usd: 0
        },
        customs_fee: {
          ces_handling_fee: 0, us_customs_fee: 0, in_bond_fee: 0,
          processing_fee: 0, transportation_fee: 0, min_cost_usd: 0
        },
        perishable_storage: {cost_per_day_min_usd: 0, cost_per_kg_per_day_usd: 0},
        cage_vault: {cost_per_day_min_usd: 0, cost_per_kg_per_day_usd: 0},
        bup_main_deck: {
          cost_usd: 0
        },
        breakdown_hawb: {
          cost_per_kg_usd: 0
        },
        import_service: {
          cost_usd: 0
        },
        return_fee: {
          cost_usd: 0
        },
        skid_exch: {
          cost_usd: 0
        },
        comat: {},
        copa_comat: {},
        nomination_fee: {
          cost_usd: 0
        },
        certified_manifest_charge: {
          cost_usd: 0
        }
      },
      working_hours: {
        import: [],
        export: []
      },
      dock_load: [],
      airlines: [],
      avg_wait_time: { hours: null, minutes: null },
      system_parameters: { forms: {} },
      gha_fwd_config: { convenience_fee_usd: 0, pay_by_invoice_allowed: false, type: InvoiceAccountType.NONE, other_payment_allowed: 'no', pay_by_wallet: false }
};

export {
  GHA_SCHEMA
}